@for (_ of [].constructor(25); track _) {
	<div class="snowflake"></div>
}
